module.exports = __webpack_public_path__ + "static/5-f4e9a1a51055d029dafd53d16813b1aa.jpeg";